import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithIsHome } from '~/core/styleTypes';

import { SpecialEvent } from './enums';

export const SHARED_SIZES = {
    network: {
        size: 240,
        maxSize: 305,
    },
    tableBody: {
        heightSmall: 72,
        heightLarge: 84,
    },
};

export const centeredFlex = `
    display: flex;
    align-items: center;
    justify-content: center;
`;

export type WithEventType = { $eventType: SpecialEvent };

export const Team = styled.div<WithIsHome>`
    align-items: center;
    display: flex;
    flex: 3;
    justify-content: ${({ $isHome }) => ($isHome ? 'start' : 'end')};
    text-align: ${({ $isHome }) => ($isHome ? 'right' : 'initial')};

    .team-display-container {
        display: initial;
        flex: initial;
    }

    .team-display {
        padding: 0 14px;

        ${BaseStyle.Mixins.screenSizes.medium} {
            padding: 0 16px;
        }
    }
`;

export const LineBreak = styled.div<{ $extraSpace?: boolean }>`
    background: ${({ theme }) => theme.Surface.border};
    display: inline-block;
    height: 24px;
    margin: 0 ${({ $extraSpace }) => ($extraSpace ? '16px' : '8px')};
    min-width: 1px;
    width: 1px;
`;

export const SmallGameLinksContainer = styled.div<WithEventType>`
    display: flex;
    align-items: center;
    padding-right: 20px;
    text-align: right;
    height: ${({ $eventType }) =>
        $eventType ? SHARED_SIZES.tableBody.heightLarge : SHARED_SIZES.tableBody.heightSmall}px;

    a {
        color: ${({ theme }) => theme.Utility.cta};
    }

    svg {
        fill: ${({ theme }) => theme.Utility.cta};
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        justify-content: center;
        padding-right: initial;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        display: none;
    }
`;

export const LargeGameLinksContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.cta};
    display: none;
    cursor: pointer;

    ${LineBreak}:last-child {
        display: none;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        ${centeredFlex};
    }
`;

export const LargeGameLink = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall};
    display: flex;
    align-items: center;

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['24m']}
        fill: ${({ theme }) => theme.Utility.cta};
    }
`;

export const LinkTag = styled.a<{ $isPlayoffSeriesPage: boolean }>`
    && {
        color: ${({ theme, $isPlayoffSeriesPage }) => ($isPlayoffSeriesPage ? theme.Text.primary : theme.Utility.cta)};
    }
`;

export const NonLinkedTag = styled.div`
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    && {
        color: ${({ theme }) => theme.Utility.cta};
    }
`;
